<template>
  <el-card>
    <div slot="header">
      <span>项目群管理</span>
      <div style="float: right">
        <el-button
          type="primary"
          icon="el-icon-refresh"
          size="small"
          :loading="syncLoading"
          @click="handleSyncGroups"
          style="margin-right: 10px"
        >同步群列表</el-button>
        <!-- <el-upload
          style="display: inline-block; margin-right: 10px"
          :action="importUrl"
          :headers="uploadHeaders"
          :show-file-list="false"
          :on-success="handleImportSuccess"
          :on-error="handleImportError"
          :before-upload="beforeImportUpload"
          accept=".xlsx,.xls"
        >
          <el-button type="success" icon="el-icon-upload2" size="small" :loading="importing">导入绑定</el-button>
        </el-upload>
        <el-button
          type="warning"
          icon="el-icon-download"
          size="small"
          @click="handleDownloadTemplate"
        >下载模板</el-button> -->
      </div>
    </div>

    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <!-- ===== Tab1：按项目查 ===== -->
      <el-tab-pane label="按项目查" name="project">
        <!-- 搜索栏 -->
        <el-form :inline="true" :model="queryInfo" size="small" class="search-form">
          <el-form-item label="关键字">
            <el-input
              v-model="queryInfo.keyword"
              placeholder="项目名/客户名"
              clearable
              @clear="getList(true)"
              @keyup.enter.native="getList(true)"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="绑定状态">
            <el-select v-model="queryInfo.bindStatus" placeholder="全部" style="width: 120px" @change="getList(true)">
              <el-option label="全部" value="all"></el-option>
              <el-option label="已绑定" value="bound"></el-option>
              <el-option label="未绑定" value="unbound"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(true)">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table :data="list" border v-loading="loading" style="width: 100%">
          <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="customerName" label="客户名称" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="signerName" label="签约人" width="100"></el-table-column>
          <el-table-column label="项目状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="flagType(scope.row.storeFlag)" size="small">
                {{ flagText(scope.row.storeFlag) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="dealDate" label="签约时间" width="110">
            <template slot-scope="scope">
              {{ scope.row.dealDate | dateFormat }}
            </template>
          </el-table-column>
          <el-table-column label="绑定状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.bound ? 'success' : 'info'" size="small">
                {{ scope.row.bound ? '已绑定' : '未绑定' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="群ID" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.conversationId">{{ scope.row.conversationId }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="群名称" min-width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.groupNickname">{{ scope.row.groupNickname }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="groupTotal" label="群人数" width="80" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.bound">{{ scope.row.groupTotal }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="绑定时间" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.boundAt">{{ scope.row.boundAt | dateFormat }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" fixed="right" align="center">
            <template slot-scope="scope">
              <!-- 失效项目（已解约/已关店）：仅允许解绑清理脏数据 -->
              <template v-if="isInactive(scope.row)">
                <el-button
                  v-if="scope.row.bound"
                  type="danger"
                  size="mini"
                  @click="handleUnbind(scope.row)"
                >解绑</el-button>
                <span v-else style="color: #c0c4cc">-</span>
              </template>
              <!-- 正常项目：可绑定/换绑/解绑 -->
              <template v-else>
                <el-button
                  v-if="!scope.row.bound"
                  type="primary"
                  size="mini"
                  @click="openBindDialog(scope.row)"
                >绑定</el-button>
                <template v-else>
                  <el-button type="warning" size="mini" @click="openBindDialog(scope.row)">换绑</el-button>
                  <el-button type="danger" size="mini" @click="handleUnbind(scope.row)">解绑</el-button>
                </template>
              </template>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[10, 20, 50]"
          :page-size="queryInfo.pagesize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          style="margin-top: 15px; text-align: right"
        ></el-pagination>
      </el-tab-pane>

      <!-- ===== Tab2：按群查 ===== -->
      <el-tab-pane label="按群查" name="group">
        <!-- 搜索栏 -->
        <el-form :inline="true" :model="groupQueryInfo" size="small" class="search-form">
          <el-form-item label="群名称">
            <el-input
              v-model="groupQueryInfo.keyword"
              placeholder="群名称关键字"
              clearable
              @clear="getGroupList(true)"
              @keyup.enter.native="getGroupList(true)"
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <el-form-item label="绑定状态">
            <el-select v-model="groupQueryInfo.bindStatus" placeholder="全部" style="width: 120px" @change="getGroupList(true)">
              <el-option label="全部" value="all"></el-option>
              <el-option label="已绑定" value="bound"></el-option>
              <el-option label="未绑定" value="unbound"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getGroupList(true)">查询</el-button>
            <el-button @click="resetGroupQuery">重置</el-button>
          </el-form-item>
        </el-form>

        <!-- 群列表 -->
        <el-table :data="groupList" border v-loading="groupLoading" style="width: 100%">
          <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
          <el-table-column prop="nickname" label="群名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column label="群ID" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.conversationId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="群人数" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.total }}</span>
              <el-tag v-if="scope.row.isExternal" type="warning" size="mini" style="margin-left: 4px">外部</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="绑定状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.bound ? 'success' : 'info'" size="small">
                {{ scope.row.bound ? '已绑定' : '未绑定' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="绑定项目" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.bound && scope.row.projectName">{{ scope.row.projectName }}</span>
              <span v-else-if="scope.row.bound" style="color: #909399">已绑定（无权查看）</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="客户名称" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.customerName">{{ scope.row.customerName }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column prop="signerName" label="签约人" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.signerName">{{ scope.row.signerName }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="项目状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.bound && scope.row.projectName" :type="flagType(scope.row.storeFlag)" size="small">
                {{ flagText(scope.row.storeFlag) }}
              </el-tag>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="绑定时间" width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.boundAt">{{ scope.row.boundAt | dateFormat }}</span>
              <span v-else style="color: #c0c4cc">-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <template v-if="!scope.row.bound">
                <el-button type="primary" size="mini" @click="openBindProjectDialog(scope.row)">绑定项目</el-button>
              </template>
              <template v-else>
                <el-button v-if="scope.row.canManage" type="danger" size="mini" @click="handleGroupUnbind(scope.row)">解绑</el-button>
                <span v-else style="color: #909399; font-size: 12px">已绑定（无权操作）</span>
              </template>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleGroupSizeChange"
          @current-change="handleGroupCurrentChange"
          :current-page="groupQueryInfo.pagenum"
          :page-sizes="[10, 20, 50]"
          :page-size="groupQueryInfo.pagesize"
          :total="groupTotal"
          layout="total, sizes, prev, pager, next, jumper"
          style="margin-top: 15px; text-align: right"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 绑定/换绑群弹窗（按项目查） -->
    <el-dialog
      :title="bindDialog.row && bindDialog.row.bound ? '换绑群' : '绑定群'"
      :visible.sync="bindDialog.visible"
      width="500px"
      @close="resetBindDialog"
    >
      <el-form label-width="90px">
        <el-form-item label="项目名称">
          <span>{{ bindDialog.row ? bindDialog.row.projectName : '' }}</span>
        </el-form-item>
        <el-form-item label="当前群" v-if="bindDialog.row && bindDialog.row.bound">
          <span>{{ bindDialog.row.groupNickname }}（{{ bindDialog.row.groupTotal }}人）</span>
        </el-form-item>
        <el-form-item label="选择群">
          <el-select
            v-model="bindDialog.conversationId"
            placeholder="搜索群名称"
            filterable
            remote
            :remote-method="searchGroups"
            :loading="bindDialog.loading"
            style="width: 100%"
          >
            <el-option
              v-for="item in groupOptions"
              :key="item.conversation_id"
              :label="`${item.nickname}（${item.total}人${item.is_external ? '·外部' : ''}）`"
              :value="item.conversation_id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="bindDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="bindDialog.submitting" @click="confirmBind">确认</el-button>
      </div>
    </el-dialog>

    <!-- 绑定项目弹窗（按群查） -->
    <el-dialog
      title="绑定项目"
      :visible.sync="bindProjectDialog.visible"
      width="520px"
      @close="resetBindProjectDialog"
    >
      <el-form label-width="90px">
        <el-form-item label="群名称">
          <span>{{ bindProjectDialog.row ? bindProjectDialog.row.nickname : '' }}</span>
          <span style="color: #909399; margin-left: 8px">（{{ bindProjectDialog.row ? bindProjectDialog.row.total : 0 }}人）</span>
        </el-form-item>
        <el-form-item label="选择项目">
          <el-select
            v-model="bindProjectDialog.projectId"
            placeholder="搜索项目名/客户名"
            filterable
            remote
            :remote-method="searchProjects"
            :loading="bindProjectDialog.loading"
            @change="handleProjectSelectChange"
            style="width: 100%"
          >
            <el-option
              v-for="item in projectOptions"
              :key="item._id"
              :label="projectOptionLabel(item)"
              :value="item._id"
            ></el-option>
          </el-select>
          <div v-if="selectedProjectBound" style="color: #e6a23c; font-size: 12px; margin-top: 4px">
            该项目已绑定群"{{ selectedProjectBound }}"，确认后将换绑到当前群，原群自动解除绑定
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="bindProjectDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="bindProjectDialog.submitting" @click="confirmBindProject">确认</el-button>
      </div>
    </el-dialog>

    <!-- 导入结果弹窗 -->
    <el-dialog
      title="导入结果"
      :visible.sync="resultDialog.visible"
      width="640px"
      :close-on-click-modal="false"
    >
      <div class="result-summary">
        <el-tag type="success" size="small">成功 {{ resultDialog.success }}</el-tag>
        <el-tag type="danger" size="small">失败 {{ resultDialog.fail }}</el-tag>
        <el-tag type="info" size="small">抢占 {{ resultDialog.preempted }}</el-tag>
        <el-tag type="info" size="small" effect="plain">跳过 {{ resultDialog.skipped }}</el-tag>
      </div>
      <el-table
        :data="resultDialog.details"
        border
        size="small"
        max-height="360"
        style="margin-top: 12px"
        empty-text="无明细"
      >
        <el-table-column prop="row" label="行号" width="70" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'fail' ? 'danger' : 'info'" size="mini">
              {{ scope.row.status === 'fail' ? '失败' : '被抢占' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="原因" min-width="180" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="resultDialog.visible = false">关闭</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'ZhaoshangProjectGroup',
  data () {
    return {
      activeTab: 'project',
      // ===== 按项目查 =====
      queryInfo: {
        keyword: '',
        bindStatus: 'all',
        pagenum: 1,
        pagesize: 20
      },
      list: [],
      total: 0,
      loading: false,
      // ===== 按群查 =====
      groupQueryInfo: {
        keyword: '',
        bindStatus: 'all',
        pagenum: 1,
        pagesize: 20
      },
      groupList: [],
      groupTotal: 0,
      groupLoading: false,
      groupTabLoaded: false,
      // ===== 导入相关 =====
      importUrl: this.$http.defaults.baseURL + 'zhaoshang/project-group/import',
      uploadHeaders: {
        authorization: window.sessionStorage.getItem('token'),
        Accept: 'application/json'
      },
      importing: false,
      // 同步群列表
      syncLoading: false,
      // 导入结果弹窗
      resultDialog: {
        visible: false,
        success: 0,
        fail: 0,
        preempted: 0,
        skipped: 0,
        details: []
      },
      // ===== 绑定群弹窗（按项目查） =====
      bindDialog: {
        visible: false,
        row: null,
        conversationId: '',
        loading: false,
        submitting: false
      },
      groupOptions: [],
      // ===== 绑定项目弹窗（按群查） =====
      bindProjectDialog: {
        visible: false,
        row: null,
        projectId: '',
        loading: false,
        submitting: false,
        // 选中项目时快照其现绑群名，避免远程搜索覆盖 projectOptions 后换绑提示丢失
        currentBoundGroup: ''
      },
      projectOptions: []
    }
  },
  computed: {
    // 当前选中项目已绑定的群名（用于换绑提示），取自选中时快照，避免 options 被远程搜索覆盖
    selectedProjectBound () {
      return this.bindProjectDialog.currentBoundGroup || ''
    }
  },
  created () {
    this.getList()
  },
  filters: {
    dateFormat (val) {
      if (!val) return ''
      return dayjs(val).format('YYYY-MM-DD')
    }
  },
  methods: {
    // 项目状态文案映射（-1=关店：解约后已释放商圈名额）
    flagText (flag) {
      const map = { 2: '营业中', 1: '筹建中', 0: '已解约', '-1': '已关店' }
      return map[flag] || '未建档'
    },
    // 项目状态颜色映射
    flagType (flag) {
      const map = { 2: 'success', 1: 'warning', 0: 'danger', '-1': 'info' }
      return map[flag] || 'info'
    },
    // 判断项目是否失效（已解约/已关店）
    isInactive (row) {
      return row.storeFlag === 0 || row.storeFlag === -1
    },
    // 切换 tab
    handleTabClick (tab) {
      if (tab.name === 'group' && !this.groupTabLoaded) {
        this.groupTabLoaded = true
        this.getGroupList(true)
      }
    },
    // ========== 按项目查 ==========
    async getList (first = false) {
      if (first) this.queryInfo.pagenum = 1
      this.loading = true
      try {
        const { data: res } = await this.$http.get('zhaoshang/project-group/list', {
          params: {
            keyword: this.queryInfo.keyword,
            bindStatus: this.queryInfo.bindStatus,
            pagenum: this.queryInfo.pagenum,
            pagesize: this.queryInfo.pagesize
          }
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.list = res.data.list
        this.total = res.data.total
      } catch (e) {
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    resetQuery () {
      this.queryInfo.keyword = ''
      this.queryInfo.bindStatus = 'all'
      this.getList(true)
    },
    handleSizeChange (size) {
      this.queryInfo.pagesize = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.queryInfo.pagenum = page
      this.getList()
    },
    // 打开绑定群弹窗
    openBindDialog (row) {
      this.bindDialog.row = row
      this.bindDialog.visible = true
      // 预加载群列表
      this.searchGroups('')
    },
    // 搜索群（远程搜索）
    async searchGroups (keyword) {
      this.bindDialog.loading = true
      try {
        const { data: res } = await this.$http.get('zhaoshang/project-group/search-groups', {
          params: { keyword }
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.groupOptions = res.data.list || []
      } catch (e) {
        this.$message.error('搜索群失败')
      } finally {
        this.bindDialog.loading = false
      }
    },
    // 确认绑定/换绑
    async confirmBind () {
      if (!this.bindDialog.conversationId) {
        return this.$message.warning('请选择群')
      }
      this.bindDialog.submitting = true
      try {
        const { data: res } = await this.$http.post('zhaoshang/project-group/bind', {
          projectId: this.bindDialog.row._id,
          conversationId: this.bindDialog.conversationId
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(this.bindDialog.row.bound ? '换绑成功' : '绑定成功')
        this.bindDialog.visible = false
        this.getList()
      } catch (e) {
        this.$message.error('操作失败')
      } finally {
        this.bindDialog.submitting = false
      }
    },
    // 解绑（按项目查）
    async handleUnbind (row) {
      try {
        await this.$confirm(`确认解除项目"${row.projectName}"的群绑定？`, '解绑确认', {
          type: 'warning'
        })
      } catch (e) {
        return // 取消
      }
      const { data: res } = await this.$http.delete(`zhaoshang/project-group/unbind/${row._id}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('解绑成功')
      this.getList()
    },
    // 重置绑定群弹窗
    resetBindDialog () {
      this.bindDialog.row = null
      this.bindDialog.conversationId = ''
      this.groupOptions = []
    },
    // ========== 按群查 ==========
    async getGroupList (first = false) {
      if (first) this.groupQueryInfo.pagenum = 1
      this.groupLoading = true
      try {
        const { data: res } = await this.$http.get('zhaoshang/project-group/group-list', {
          params: {
            keyword: this.groupQueryInfo.keyword,
            bindStatus: this.groupQueryInfo.bindStatus,
            pagenum: this.groupQueryInfo.pagenum,
            pagesize: this.groupQueryInfo.pagesize
          }
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.groupList = res.data.list
        this.groupTotal = res.data.total
      } catch (e) {
        this.$message.error('获取群列表失败')
      } finally {
        this.groupLoading = false
      }
    },
    resetGroupQuery () {
      this.groupQueryInfo.keyword = ''
      this.groupQueryInfo.bindStatus = 'all'
      this.getGroupList(true)
    },
    handleGroupSizeChange (size) {
      this.groupQueryInfo.pagesize = size
      this.getGroupList()
    },
    handleGroupCurrentChange (page) {
      this.groupQueryInfo.pagenum = page
      this.getGroupList()
    },
    // 项目选项 label 组装
    projectOptionLabel (item) {
      let label = item.projectName
      if (item.customerName) label += ` · ${item.customerName}`
      if (item.signerName) label += ` · ${item.signerName}`
      if (item.currentGroupNickname) label += `（现绑：${item.currentGroupNickname}）`
      return label
    },
    // 打开绑定项目弹窗
    openBindProjectDialog (row) {
      this.bindProjectDialog.row = row
      this.bindProjectDialog.visible = true
      // 预加载项目列表
      this.searchProjects('')
    },
    // 选中项目时快照现绑群名（避免远程搜索覆盖 options 后提示丢失）
    handleProjectSelectChange (val) {
      const item = val ? this.projectOptions.find(p => p._id === val) : null
      this.bindProjectDialog.currentBoundGroup = item && item.currentGroupNickname ? item.currentGroupNickname : ''
    },
    // 搜索可绑定的项目（远程搜索）
    async searchProjects (keyword) {
      this.bindProjectDialog.loading = true
      try {
        const { data: res } = await this.$http.get('zhaoshang/project-group/search-projects', {
          params: { keyword }
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.projectOptions = res.data.list || []
      } catch (e) {
        this.$message.error('搜索项目失败')
      } finally {
        this.bindProjectDialog.loading = false
      }
    },
    // 确认绑定项目（群 → 项目）
    async confirmBindProject () {
      if (!this.bindProjectDialog.projectId) {
        return this.$message.warning('请选择项目')
      }
      // 若选中项目已绑别的群，二次确认
      if (this.selectedProjectBound) {
        try {
          await this.$confirm(
            `该项目已绑定群"${this.selectedProjectBound}"，确认换绑到当前群？原群将自动解除绑定。`,
            '换绑确认',
            { type: 'warning' }
          )
        } catch (e) {
          return // 取消
        }
      }
      this.bindProjectDialog.submitting = true
      try {
        const { data: res } = await this.$http.post('zhaoshang/project-group/bind', {
          projectId: this.bindProjectDialog.projectId,
          conversationId: this.bindProjectDialog.row.conversationId
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('绑定成功')
        this.bindProjectDialog.visible = false
        this.getGroupList()
      } catch (e) {
        this.$message.error('操作失败')
      } finally {
        this.bindProjectDialog.submitting = false
      }
    },
    // 解绑（按群查）
    async handleGroupUnbind (row) {
      const projName = row.projectName || '该项目'
      try {
        await this.$confirm(`确认解除群"${row.nickname}"与项目"${projName}"的绑定？`, '解绑确认', {
          type: 'warning'
        })
      } catch (e) {
        return // 取消
      }
      const { data: res } = await this.$http.delete(`zhaoshang/project-group/unbind/${row.projectId}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$message.success('解绑成功')
      this.getGroupList()
    },
    // 重置绑定项目弹窗
    resetBindProjectDialog () {
      this.bindProjectDialog.row = null
      this.bindProjectDialog.projectId = ''
      this.bindProjectDialog.currentBoundGroup = ''
      this.projectOptions = []
    },
    // ========== 导入 ==========
    // 导入前校验
    beforeImportUpload (file) {
      const isExcel = /\.(xlsx|xls)$/i.test(file.name)
      if (!isExcel) {
        this.$message.error('仅支持 xlsx/xls 格式文件')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
        return false
      }
      this.importing = true
      return true
    },
    // 导入成功回调
    handleImportSuccess (res) {
      this.importing = false
      if (!res || !res.meta || res.meta.status !== 200) {
        return this.$message.error((res && res.meta && res.meta.msg) || '导入失败')
      }
      const d = res.data || {}
      // 全部成功且无抢占 → 简单提示
      if (!d.fail && !d.preempted) {
        this.$message.success(res.meta.msg || '导入成功')
      } else {
        // 有失败或抢占 → 弹窗表格展示明细
        this.resultDialog.success = d.success || 0
        this.resultDialog.fail = d.fail || 0
        this.resultDialog.preempted = d.preempted || 0
        this.resultDialog.skipped = d.skipped || 0
        this.resultDialog.details = d.details || []
        this.resultDialog.visible = true
      }
      // 导入影响两个 tab 的数据，按当前所在 tab 刷新可见列表
      if (this.activeTab === 'group') {
        this.getGroupList()
      } else {
        this.getList()
      }
    },
    // 导入失败回调
    handleImportError () {
      this.importing = false
      this.$message.error('导入失败，请检查文件格式')
    },
    // 同步群列表（从采集端拉取最新企微群数据到 wework_groups）
    async handleSyncGroups () {
      this.syncLoading = true
      try {
        const { data: res } = await this.$http.post('zhaoshang/project-group/sync-groups')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg || '同步失败')
        }
        this.$message.success(`同步完成，共处理 ${res.data.synced} 个群`)
        // 同步影响群数据，按当前 tab 刷新可见列表
        if (this.activeTab === 'group') {
          this.getGroupList()
        } else {
          this.getList()
        }
      } catch (e) {
        this.$message.error('请求失败')
      } finally {
        this.syncLoading = false
      }
    },
    // 下载模板
    async handleDownloadTemplate () {
      try {
        const { data } = await this.$http.get('zhaoshang/project-group/template', { responseType: 'blob' })
        this._downloadBlob(data, '项目群绑定导入模板.xlsx')
      } catch (e) {
        this.$message.error('下载模板失败')
      }
    },
    // 通用 blob 下载辅助
    _downloadBlob (blob, filename) {
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  }
}
</script>

<style lang="less" scoped>
.search-form {
  margin-bottom: 15px;
}
.result-summary {
  .el-tag + .el-tag {
    margin-left: 8px;
  }
}
</style>
